enum ArtOrderStatus {
  ACCEPTING_OFFERS = "ACCEPTING_OFFERS",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  DELIVERED = "DELIVERED",
}

const ArtOrderMessageByStatus = {
  [ArtOrderStatus.ACCEPTING_OFFERS]: "Accepting offers",
  [ArtOrderStatus.ACCEPTED]: "Offer accepted!",
  [ArtOrderStatus.DECLINED]: "Offer declined",
  [ArtOrderStatus.DELIVERED]: "Delivered",
};

const ArtOrderTextColorByStatus = {
  [ArtOrderStatus.ACCEPTING_OFFERS]: "text-yellow endemic:text-white",
  [ArtOrderStatus.ACCEPTED]: "text-green endemic:text-white",
  [ArtOrderStatus.DECLINED]: "text-red endemic:text-white",
  [ArtOrderStatus.DELIVERED]: "text-primary",
};

const ART_ORDER_PAGE_SIZE = 10;
const ART_ORDER_DEFAULT_PAGE = 1;

const ART_ORDERS_ROUTE = "/art-orders";
const ART_ORDER_ROUTE = "/art-order";
const ART_ORDER_CREATE_URL_ROUTE = `${ART_ORDER_ROUTE}/create`;

export {
  ArtOrderStatus,
  ArtOrderMessageByStatus,
  ArtOrderTextColorByStatus,
  ART_ORDER_PAGE_SIZE,
  ART_ORDER_DEFAULT_PAGE,
  ART_ORDER_ROUTE,
  ART_ORDERS_ROUTE,
  ART_ORDER_CREATE_URL_ROUTE,
};
